import moment from "moment";
import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";

const validateDDMMYYYY = (value) => {
  if (!value) return true;
  const date = moment(value, "DD/MM/YYYY", true);
  return date.isValid();
};

const validateMMYYYY = (value) => {
  if (!value) return true;
  const date = moment(value, "MM/YYYY", true);
  return date.isValid();
};

const PreviousAddressForm = ({ appData, postRoyalMailFormFunc }) => {
  const {
    title = "",
    firstName = "",
    lastName = "",
    dateOfBirth = moment(),
    nationalInsuranceNo = "",
  } = appData;

  let initialData = {
    title,
    firstName,
    lastName,
    dateOfBirth: moment(dateOfBirth).format("DD/MM/YYYY"),
    NInumber: nationalInsuranceNo,
    signed: `${firstName} ${lastName}`,
    dateSigned: moment().format("DD/MM/YYYY"),
  };

  if (
    appData.royalMailOnboarding &&
    appData.royalMailOnboarding.previousAddresses
  ) {
    initialData = {
      ...initialData,
      ...appData.royalMailOnboarding.previousAddresses,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";
  const getVal = getField(initialData);

  const initialState = {
    title: {
      title: "Title:",
      value: getVal("title"),
      mandatory: true,
    },
    lastName: {
      title: "Surname:",
      value: getVal("lastName"),
      mandatory: true,
    },
    firstName: {
      title: "First name:",
      value: getVal("firstName"),
      mandatory: true,
    },
    middleName: { title: "Middle name(s):", value: getVal("middleName") },
    dateOfBirth: {
      title: "Date of birth:",
      value: getVal("dateOfBirth"),
      validate: validateDDMMYYYY,
      mandatory: true,
    },
    NInumber: {
      title: "National insurance number:",
      value: getVal("NInumber"),
      mandatory: true,
    },
    prevAddr1Delimiter: {
      htmlObj: <HorizontalLine text={"Previous Address 1"} />,
    },
    prevAddr1Line1: {
      title: "Address line 1:",
      value: getVal("prevAddr1Line1"),
    },
    prevAddr1Line2: {
      title: "Address line 2:",
      value: getVal("prevAddr1Line2"),
    },
    postTown1: { title: "Post town:", value: getVal("postTown1") },
    postCode1: { title: "Post code:", value: getVal("postCode1") },
    country1: { title: "Country:", value: getVal("country1") },
    residentAddr1: {
      title: "Resident at this address from (mm/yyyy):",
      value: getVal("residentAddr1"),
      validate: validateMMYYYY,
    },
    prevAddr2Delimiter: {
      htmlObj: <HorizontalLine text={"Previous Address 2"} />,
    },
    prevAddr2Line1: {
      title: "Address line 1:",
      value: getVal("prevAddr2Line1"),
    },
    prevAddr2Line2: {
      title: "Address line 2:",
      value: getVal("prevAddr2Line2"),
    },
    postTown2: { title: "Post town:", value: getVal("postTown2") },
    postCode2: { title: "Post code:", value: getVal("postCode2") },
    country2: { title: "Country:", value: getVal("country2") },
    residentAddr2: {
      title: "Resident at this address from (mm/yyyy):",
      value: getVal("residentAddr2"),
      validate: validateMMYYYY,
    },
    prevAddr3Delimiter: {
      htmlObj: <HorizontalLine text={"Previous Address 3"} />,
    },
    prevAddr3Line1: {
      title: "Address line 1:",
      value: getVal("prevAddr3Line1"),
    },
    prevAddr3Line2: {
      title: "Address line 2:",
      value: getVal("prevAddr3Line2"),
    },
    postTown3: { title: "Post town:", value: getVal("postTown3") },
    postCode3: { title: "Post code:", value: getVal("postCode3") },
    country3: { title: "Country:", value: getVal("country3") },
    residentAddr3: {
      title: "Resident at this address from (mm/yyyy):",
      value: getVal("residentAddr3"),
      validate: validateMMYYYY,
    },
    prevAddr4Delimiter: {
      htmlObj: <HorizontalLine text={"Previous Address 4"} />,
    },
    prevAddr4Line1: {
      title: "Address line 1:",
      value: getVal("prevAddr4Line1"),
    },
    prevAddr4Line2: {
      title: "Address line 2:",
      value: getVal("prevAddr4Line2"),
    },
    postTown4: { title: "Post town:", value: getVal("postTown4") },
    postCode4: { title: "Post code:", value: getVal("postCode4") },
    country4: { title: "Country:", value: getVal("country4") },
    residentAddr4: {
      title: "Resident at this address from (mm/yyyy):",
      value: getVal("residentAddr4"),
      validate: validateMMYYYY,
    },
    prevAddr5Delimiter: {
      htmlObj: <HorizontalLine text={"Previous Address 5"} />,
    },
    prevAddr5Line1: {
      title: "Address line 1:",
      value: getVal("prevAddr5Line1"),
    },
    prevAddr5Line2: {
      title: "Address line 2:",
      value: getVal("prevAddr5Line2"),
    },
    postTown5: { title: "Post town:", value: getVal("postTown5") },
    postCode5: { title: "Post code:", value: getVal("postCode5") },
    country5: { title: "Country:", value: getVal("country5") },
    residentAddr5: {
      title: "Resident at this address from (mm/yyyy):",
      value: getVal("residentAddr5"),
      validate: validateMMYYYY,
    },
    Signdelimiter: {
      htmlObj: (
        <HorizontalLine
          text={"Signature & Date"}
          desc={
            "The return of this document replaces the requirement for your handwritten signature."
          }
        />
      ),
    },
    signed: { title: "Signed:", value: getVal("signed"), mandatory: true },
    dateSigned: {
      title: "Date:",
      value: getVal("dateSigned"),
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postRoyalMailFormFunc(
      "previousAddresses",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/royal-mail-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Additional Previous Address Form"}
      description={
        "This form should only be completed if your current address does not cover a full 5 years."
      }
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};
PreviousAddressForm.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(PreviousAddressForm);
